function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7772 0.21159C11.6289 0.0704909 11.4531 0 11.2499 0H0.750056C0.546802 0 0.371088 0.0704909 0.222628 0.21159C0.0741683 0.352844 0 0.519846 0 0.712905C0 0.905926 0.0741683 1.07293 0.222628 1.21407L5.47257 6.2037C5.6212 6.3448 5.79691 6.41545 6 6.41545C6.20309 6.41545 6.37897 6.3448 6.52731 6.2037L11.7772 1.21403C11.9255 1.07293 12 0.905926 12 0.712866C12 0.519846 11.9255 0.352844 11.7772 0.21159Z",
  fill: "#7D86A9"
});

function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.39700d6f.svg";
export { ForwardRef as ReactComponent };